"use strict";
const ActionableIcon = require("../actionable/ActionableIcon");
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

class ToggleIcon extends ActionableIcon {
    createdCallback() {
        super.createdCallback(arguments);
        this._toggled = false;
        this._icon = undefined;
        this._toggledIcon = undefined;
    }

    attachedCallback() {
        super.attachedCallback();
        if (this.hasAttribute("data-toggled")) {
            let toggled = this.dataset.toggled;
            if (toggled === "true" || toggled === "1") {
                this.setToggled(true);
            } else {
                this.setToggled(false);
            }
        }
    }

    // attributeChangedCallback(/*attrName, oldVal, newVal*/){
    //     super.attributeChangedCallback(arguments);
    // }

    // detachedCallback(){
    //     super.detachedCallback(arguments);
    // }

    _loadIcon() {
        let iconNamespace = this.dataset.icon;
        if (iconNamespace) {
            let iconSvg = IconRegistry.getRegisteredIcon(iconNamespace);
            if (iconSvg && iconSvg.icon) {
                this._icon = iconSvg.icon;
                this._toggledIcon = iconSvg.toggledIcon ? iconSvg.toggledIcon : iconSvg.icon;
                this._setIcon();
            } else {
                let err = "Invalid Icon Reference or missing icons property: " + iconNamespace;
                console.error(err);
                this._icon = IconRegistry.getRegisteredIcon("toggled.skullbomb").icon;
                this._toggledIcon = IconRegistry.getRegisteredIcon("toggled.skullbomb").toggledIcon;
                this._setIcon();
                this.setAttribute("title", err);
            }
        } else {
            let err = "Missing data-icon attribute.";
            console.error(err);
            this._icon = IconRegistry.getRegisteredIcon("toggled.skullbomb").icon;
            this._toggledIcon = IconRegistry.getRegisteredIcon("toggled.skullbomb").toggledIcon;
            this._setIcon();
            this.setAttribute("title", err);
        }
    }

    _setIcon() {
        let icon = this._toggled ? this._toggledIcon : this._icon;
        this.innerHTML = icon;
    }

    toggle() {
        this.setToggled(!this._toggled);
    }

    isToggled() {
        return this.getToggled();
    }
    get toggled() {
        return this.getToggled();
    }

    set toggled(bool) {
        this.setToggled(bool);
    }

    getToggled() {
        return this._toggled;
    }

    setToggled(bool) {
        if (bool !== this._toggled) {
            if (bool) {
                this._toggled = true;
                this.classList.add("toggled");
            } else {
                this._toggled = false;
                this.classList.remove("toggled");
            }
            this._setIcon();
        }
    }
}

let icon,
    customElementRegistry = window.customElements;

if (customElementRegistry) {
    icon = customElementRegistry.get("toggle-icon-gl");
    if (!icon) {
        customElementRegistry.define("toggle-icon-gl", ToggleIcon);
        icon = customElementRegistry.get("toggle-icon-gl");
    }
} else if (document.registerElement) {
    icon = document.registerElement("toggle-icon-gl", ToggleIcon);
} else {
    icon = ToggleIcon;
}

module.exports = icon;
